import { createContext, useContext } from "react";

import { ProgressBarContextType } from "../types";

export const ProgressBarContext =
  // @ts-ignore
  createContext<ProgressBarContextType>();

export const useProgressBarContext = () => useContext(ProgressBarContext);
